import { Link } from "react-router-dom";
import { ShieldAlert } from "lucide-react";
import { Button } from "../../ui/button";
import { Page, H1, H2, Lead, P, UL, Notice } from "../../public/primitives";
import { legal } from "../../../config/legal";

export const SecurityDisclosurePage = () => (
  <Page testid="security-disclosure-page">
    <H1>Signalement de vulnérabilité</H1>
    <Lead>
      Vous pensez avoir découvert une faille de sécurité dans SecurePass ? Nous accueillons les
      signalements responsables et vous en remercions.
    </Lead>

    <H2 id="comment">Comment signaler</H2>
    <P>
      Adressez votre signalement via la
      <Link to="/contact?subject=security" className="text-emerald-600 underline"> page Contact</Link>
      {legal.securityEmail ? <> ou à {legal.securityEmail}</> : null}. Aucune adresse e-mail de sécurité
      dédiée n'est publiée tant qu'elle n'est pas configurée.
    </P>
    <div className="mt-4">
      <Link to="/contact?subject=security">
        <Button data-testid="security-report-btn" className="bg-emerald-500 hover:bg-emerald-400 text-emerald-950 font-semibold">
          <ShieldAlert className="w-4 h-4 mr-2" /> Signaler une vulnérabilité
        </Button>
      </Link>
    </div>

    <H2 id="informations">Informations utiles</H2>
    <UL>
      <li>Description de la vulnérabilité et de son impact potentiel.</li>
      <li>Étapes de reproduction claires.</li>
      <li>Composant, URL ou requête concernés.</li>
      <li>Vos coordonnées pour un éventuel échange.</li>
    </UL>

    <H2 id="regles">Règles de divulgation responsable</H2>
    <UL>
      <li>Ne transmettez jamais de secret réel dans votre signalement.</li>
      <li>N'exfiltrez pas de données et ne portez pas atteinte à la vie privée d'autrui.</li>
      <li>Ne perturbez pas volontairement le service (pas de déni de service, pas de destruction).</li>
      <li>Agissez de bonne foi.</li>
      <li>Laissez un délai raisonnable d'analyse et de correction avant toute publication.</li>
    </UL>

    <Notice testid="security-disclosure-note">
      SecurePass ne promet ni programme de récompense (bug bounty), ni rémunération, ni immunité
      juridique absolue, ni délai de réponse garanti. Chaque signalement de bonne foi est néanmoins
      étudié avec sérieux.
    </Notice>
  </Page>
);

export default SecurityDisclosurePage;
